import type { Load } from "@sveltejs/kit";
import type { ProductPageConfig } from '@agapi/content-storyblok';
import type { BlogPost } from "../../components";

import { error } from '@sveltejs/kit';

import { getCommerce } from '../../services';
import { getLocaleFromUrl } from "../../utils";
import { getBlogPosts, getProductPageConfig } from "../../clients/storyblok.client";
import type { ProductServerLoad } from "./server";

interface ProductLoad extends Partial<Record<string, string>> {
  slug: string;
}

interface ProductLoadResponse extends Record<string, unknown> {
  product: any;
  productConfig: ProductPageConfig;
  relatedBlogPosts: BlogPost[];
}

export const load: Load<ProductLoad, ProductServerLoad> = async ({ params, fetch, url, setHeaders, data }) => {
  setHeaders({ 'Cache-Control': 'max-age=0, s-maxage=86400' });

  const identifier = 'default';
  console.log('[product/[slug]/+page.ts] load', params);

  const locale = getLocaleFromUrl(url);

  const COMMERCE = getCommerce(fetch);
  const product = await COMMERCE.getProduct(params.slug, locale, { userId: identifier });

  if (!product?.item) {
    throw error(404, { message: 'Product not found' });
  }

  const productItem = product.item;
  const relatedBlogPosts = productItem.relatedBlogPosts ? await getBlogPosts(fetch, { locale: locale.language, slugs: productItem.relatedBlogPosts }) : undefined;

  return {
    product: productItem,
    productConfig: data.productConfigPage,
    relatedBlogPosts
  };
};
